import { useEffect } from 'react'
import { obstaclePositions } from '../../config/obstaclePositions'
import { useRunState } from '../../provider/useRunState'
import { useTrackController } from '../track/useTrackController'
import { batteryObstacleDestroyRange } from '../../config/constants'
import { BATTERY_OBSTACLE_LIGHTNING_EVENT } from '../obstacles/batteryObstacleLightningEvents'

export function BatteryEffect() {
    const runState = useRunState()
    const trackController = useTrackController()

    useEffect(() => {
        const handleTrigger = () => {
            if (runState.snapshot.batteryCount <= 0) return
            if (runState.phase !== 'running') return
            const trackPosition = trackController.getTrackPlaybackState().trackPosition
            const obstacleIds = obstaclePositions.flatMap((placement, index) => {
                const obstacleId = `obstacle-path-${index}`
                if (runState.hiddenObstacleIds.has(obstacleId)) return []

                const delta = placement.position - trackPosition
                if (delta <= 0 || delta > batteryObstacleDestroyRange) return []

                return [obstacleId]
            })
            if (obstacleIds.length === 0) return
            window.dispatchEvent(new CustomEvent(BATTERY_OBSTACLE_LIGHTNING_EVENT, {
                detail: { obstacleIds },
            }))
            runState.useBattery(obstacleIds)
        }

        window.addEventListener('snap-trigger', handleTrigger)
        return () => window.removeEventListener('snap-trigger', handleTrigger)
    }, [runState, trackController])

    return null
}
